import Swiper, { Navigation } from "swiper";

export default class DevelopmentCards {
    constructor() {
        this.sliders = document.querySelectorAll('.js-development-card-slider');
        
        this.sliders.forEach(el => {
            let isNested = false;
            if(el.closest('.js-featured-developments')){
                isNested = true;
            }
            this.init(el, isNested);
        });
    }

    init(el, isNested) {

        let swiper = new Swiper(el, {
            modules: [Navigation],
            loop:true,
            spaceBetween: 8,
            slidesPerView: 1,
            allowTouchMove: false,
            direction:'horizontal',
            nested:isNested,
            navigation: {
                nextEl: el.querySelector(`.js-development-card-slider-next`),
                prevEl: el.querySelector(`.js-development-card-slider-prev`),
            },
            breakpoints: {
                1024: {
                    allowTouchMove: true,
                }
            }
        });

    }
}

new DevelopmentCards;